import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';

import Whychooseimg03 from '../../assets/images/will3.png';

const Whychoosetwo = () => {
    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll(
                '.why-choose-two-image'
            );

            elements.forEach((el) => {
                const elementTop = el.getBoundingClientRect().top;
                const elementBottom = el.getBoundingClientRect().bottom;
                const viewportTop = 0;
                const viewportBottom = window.innerHeight;

                if (elementBottom > viewportTop && elementTop < viewportBottom) {
                    el.classList.add('active');
                }
            });
        };


        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });
   
    return (
        <div className="why-choose-two pb-4" >
            
            <div className="container" id='about-will'>
                <div className="row ">
                    <div className="col-lg-7 align-self-center">
                        <div className="why-choose-right-two">
                            <div className="heading-box heading-white">
                                
                                <h2 className="heading-title wow fadeInUp animated animated text-black" style={{marginBottom: '30px', lineHeight: "1em"}}>
                                Will execution, simplified. Peace of mind, delivered.
                                </h2>
                            </div>
                            <p style={{paddingBottom: "0", marginBottom: '30px',}}>
                            We help Non-Resident Indians draft and execute legally valid Wills in India—completely remotely. No flights. No confusing paperwork. No wondering “Did I miss something?” Just peace of mind for you and your family.
                            </p>
                            <h3 style={{marginTop: "1", paddingTop: "5px", paddingBottom: "0px", marginBottom: "10px"}}>What We Help You Do</h3>
                            <ul className='features-one-list1 main px-3' style={{display: "flex", flexDirection: "column", flexWrap: "nowrap", paddingBottom: "2em", paddingTop: "0px", marginTop: "0px"}}>
                                <li style={{marginTop: '0px', paddingTop: "0px"}}>We help you draft a personalized Will that covers your assets in India and abroad.</li>
                                <li>We take care of all legalities to ensure that your Will is protected under Indian law.</li>
                            </ul>
                            <p>All while you are sitting comfortably in your current city, anywhere in Canada.</p>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="why-choose-two-image">
                            <img
                                src={Whychooseimg03} alt="why-choose-image"
                            />
                            <div className="image-shape">
                                <span />
                                <span />
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-12 mt-5">
                        <div className="row gutter-y-30">
                            {whychoosedata.map((data, index) =>
                                <div key={index}
                                    className="col-lg-4" >
                                    <div className="why-choose-two-box">
                                        <i className="flaticon-transparency" />
                                        <div className="why-choose-two-box-info">
                                            <h4>{data.heading}</h4>
                                            <p>
                                                {data.about}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> */}
                </div>
            </div>
        </div >


    )
}
export default Whychoosetwo;